export const DRILLDOWN_REQUEST_TIMEOUT_MS = 30000;

/**
 * Races a request against a timeout. On timeout the request is aborted (to free
 * the socket) and the returned promise rejects with a TimeoutError. A plain
 * abort of the controller by other code stays silent (the request resolves),
 * so latest-wins cancellation can still be layered on top.
 */
export function withTimeout<T>(
  request: Promise<T>,
  controller: AbortController,
  ms: number = DRILLDOWN_REQUEST_TIMEOUT_MS
): Promise<T> {
  let timer: ReturnType<typeof setTimeout>;

  // tslint:disable-next-line:variable-name
  const timeout = new Promise<T>((_resolve, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      const error = new Error('Request timed out');
      error.name = 'TimeoutError';
      reject(error);
    }, ms);
  });

  return Promise.race([request, timeout]).then(
    (result) => {
      clearTimeout(timer);
      return result;
    },
    (error) => {
      clearTimeout(timer);
      return Promise.reject(error);
    }
  );
}
